import { useEffect, useState } from "react";
import { load_storage } from "../../utils/localstorage";

type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

interface ApiResponse<T> {
  data?: T;
  error?: string;
}

export async function requestApi<T>(
  url: string,
  method: HttpMethod,
  body?: any
): Promise<ApiResponse<T>> {
  try {
    const token = load_storage("access_token");

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      let errorMessage = `Error: ${response.status}`;
      const errorResponseData = await response.json();
      console.log(errorResponseData);
      if (errorResponseData && errorResponseData.message) {
        errorMessage += ` - ${errorResponseData.message}`;
      }
      throw new Error(errorMessage);
    }

    const responseData: T = await response.json();
    return { data: responseData };
  } catch (error: any) {
    return { error: error.message };
  }
}

export async function queryApi<T>(
  path: string,
  method: HttpMethod,
  body?: any
): Promise<ApiResponse<T>> {
  const token = load_storage("access_token");

  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `${token}` : "",
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    let errorMessage = `Error: ${response.status}`;
    const errorResponseData = await response.json();
    console.log(errorResponseData);
    if (errorResponseData && errorResponseData.message) {
      errorMessage += ` - ${errorResponseData.message}`;
    }
    if (!!errorResponseData.error_code) {
      return errorResponseData;
    } else {
      throw new Error(errorMessage);
    }
  }

  const responseData: T = await response.json();

  // @ts-ignore
  return responseData;
}
